import { Injectable } from '@angular/core';
import {
  PositionDTO,
  ChecklistDTO,
  FormDTO,
  IdentificationStartDTO,
  OcrCheckDTO
} from '@api/models';
import { OutputAdapterService } from '@core/modules/api/services/output-adapter/output-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class OutputAdapterCustomService extends OutputAdapterService {
  constructor() {
    super();
  }

  getChecklist(output: any): ChecklistDTO {
    output.entities.forEach(entity => {
      entity.documents.forEach(doc => {
        if (!doc.lastUpload && !!doc.files && !!doc.files[0]) {
          doc.lastUpload = doc.files[0];
        }
      });
    });

    return output;
  }

  getChecklistDocumentCheckOcr(output: {
    gap: 'FULL' | 'PARTIAL' | 'NONE';
    detectedData: { field: string; value: string }[];
    enteredData: { field: string; value: string }[];
    docCode: string;
    editStepCode: string;
  }): OcrCheckDTO {
    console.log(output);
    return {
      outcome:
        output.gap === 'FULL' ? 'KO' : output.gap === 'PARTIAL' ? 'GAP' : 'OK',
      ocrChecks: [],
      disambiguation: {
        detectedData: output.detectedData,
        enteredData: output.enteredData,
        docCode: output.docCode,
        stepCode: output.editStepCode
      }
    };
  }

  getForm(output: any): FormDTO[] {
    output.forEach(form => {
      form.titleVisible = true;

      form.sections.forEach(section => {
        section.rows.forEach(row => {
          row.fields.forEach(field => {
            if (!field.requiredExr && !!field.required) {
              field.requiredExr = field.required;
            }
          });
        });
      });
    });

    return output;
  }

  getPosition(output: any): PositionDTO {
    const customer = (output.customers && output.customers[0]) || {};

    return {
      ...output,
      phaseCode: output.status.phaseId,
      statusCode: output.status.statusCode,
      customer: {
        residenceAddress: {
          nation: customer.resNation,
          province: customer.resProvince,
          extendedProvince: customer.resExtendedProvince,
          city: customer.resCity,
          cityCadCode: customer.resCityCadCode,
          dug: customer.resDug,
          address: customer.resAddress,
          houseNumber: customer.resHouseNumber,
          zipCode: customer.resZipCode,
          cap: customer.resCap,
          co: customer.resCO,
          place: customer.resPlace,
          reviewToSkip: customer.resNation !== 'ITALIA'
        },
        domicileAddress: {
          nation: customer.domNation,
          province: customer.domProvince,
          extendedProvince: customer.domExtendedProvince,
          city: customer.domCity,
          cityCadCode: customer.domCityCadCode,
          dug: customer.domDug,
          address: customer.domAddress,
          houseNumber: customer.domHouseNumber,
          zipCode: customer.domZipCode,
          cap: customer.domCap,
          co: customer.domCO,
          place: customer.domPlace,
          reviewToSkip: customer.domNation !== 'ITALIA'
        },
        shippingAddress: {
          nation: customer.shippingNation,
          province: customer.shippingProvince,
          extendedProvince: customer.shippingExtendedProvince,
          city: customer.shippingCity,
          cityCadCode: customer.shippingCityCadCode,
          dug: customer.shippingDug,
          address: customer.shippingAddress,
          houseNumber: customer.shippingHouseNumber,
          zipCode: customer.shippingZipCode,
          cap: customer.shippingCap,
          co: customer.shippingCO,
          place: customer.shippingPlace,
          reviewToSkip: customer.shippingNation !== 'ITALIA'
        }
      }
    };
  }

  postIdentificationStart(output: any): IdentificationStartDTO {
    return {
      consumerUrl: output.consumerUrl,
      identifier: null,
      method: 'POST',
      attributes: {
        ['RelayState']: output.relayState,
        ['SAMLRequest']: output.richiestaSaml
      }
    };
  }
}
